import { Dispatch } from "redux";
import Action from "../../interfaces/Action";
import ActionTypeEnum from "../../enums/ActionTypeEnum";
import ThunkAction from "../../interfaces/ThunkAction";
import CartShippingClient from "../../clients/cart/CartShippingClient";
import ShippingQuoteSelectedAssociation from "../../interfaces/shipping-quote/ShippingQuoteSelectedAssociation";
import Cart from "../../interfaces/cart/Cart";
import { setCart } from "./cartActions";
import { ShippingQuoteGroups } from "../../interfaces/shipping-quote/ShippingQuoteGroup";

// ------------------------- [ Action Creators ] -------------------------

const setShippingQuotes = (quotes: ShippingQuoteGroups): Action => ({
    type: ActionTypeEnum.SHIPPING_QUOTES_SET,
    quotes,
});

// ------------------------- [ Thunks ] -------------------------

const cartShippingClient = new CartShippingClient();

export const loadShippingQuotes = (cartUuid: string): ThunkAction<Promise<ShippingQuoteGroups>> => (
    async (dispatch: Dispatch) => {
        const response = await cartShippingClient.getShippingQuotes(cartUuid);
        dispatch(setShippingQuotes(response.data));

        return response.data;
    }
);

export const updateShippingQuotesSelected = (cartUuid: string, associations: ShippingQuoteSelectedAssociation[]): ThunkAction<Promise<Cart>> => (
    async (dispatch: Dispatch) => {
        const response = await cartShippingClient.updateShippingQuotesSelected(cartUuid, associations);
        dispatch(setCart(response.data));

        return response.data;
    }
);
